// @module Ames.DotDigitalTracker.DotDigtalTracker
define('Ames.DotDigitalTracker.DotDigtalTracker.View'
,	[
	'ames_dotdigitaltracker_dotdigtaltracker.tpl'
	
	,	'Ames.DotDigitalTracker.DotDigtalTracker.SS2Model'
	
	,	'Backbone'
    ]
, function (
	ames_dotdigitaltracker_dotdigtaltracker_tpl
	
	,	DotDigtalTrackerSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Ames.DotDigitalTracker.DotDigtalTracker.View @extends Backbone.View
	return Backbone.View.extend({

		template: ames_dotdigitaltracker_dotdigtaltracker_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new DotDigtalTrackerModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Ames.DotDigitalTracker.DotDigtalTracker.View.Context
	,	getContext: function getContext()
		{
			//@class Ames.DotDigitalTracker.DotDigtalTracker.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
